import { render } from "./InstitutionHeader.vue?vue&type=template&id=ae7727e6"
import script from "./InstitutionHeader.vue?vue&type=script&lang=js"
export * from "./InstitutionHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__